import React from 'react'
import advisorTypes from '../../data/advisorTypes.json'
import { stringToSEO } from '../../utils/stringOps'

function ShowCourtsAndJudiciaries ({ courts }) {
  return (
    <>
      {(courts.length > 0) ? (
        <div className='article-courts box-container'>
          <div className='box-header'>Courts and Judiciaries</div>
          <div className='box-inner'>
            {courts.map(content =>
              (
                <div className='court-item item-content' key={content.id + content.title_2}>
                  <b><a href={`/#/content/${content.id}/${stringToSEO(content.title)}?referrer=portfolio_related_entityindividual`} rel='noopener noreferrer' target='_self'>{content.title}</a></b>
                  {(content.caseId != undefined && content.caseId.length > 0) ? <div>{content.caseId}</div> : null}
                  <div className='item'>
                    {(content.title_2.toLowerCase() === 'undisclosed' || content.title_2.toLowerCase() === 'internal')
                      ? <>{content.title_2} </>
                      : <a href={`/#/content/${content.id_2}/${stringToSEO(content.title_2)}?referrer=portfolio_related_entityindividual`} rel='noopener noreferrer' target='_self'>{content.title_2} </a>}
                    ({advisorTypes.filter(x => x.id === content.type)[0].name})
                  </div>
                </div>
              ))}
          </div>
        </div>
      ) : null}
    </>
  )
}

export default ShowCourtsAndJudiciaries
